import { render, staticRenderFns } from "./PendingArticles.vue?vue&type=template&id=78b12650&"
import script from "./PendingArticles.vue?vue&type=script&lang=js&"
export * from "./PendingArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports